@if (loading) {
  <div style="text-align: center; padding: 40px; color: #aaa;">Loading campaign data...</div>
} @else {

  <!-- Top Bar -->
  <div class="campaign-top-bar">
    <div class="campaign-gems-section">
      @if (!hasSearchedGems) {
        <span style="margin-right: 6px;">
          Enter your searched gems to see quest gem rewards:
        </span>
      } @else {
        <span class="extra-info" style="margin-right: 6px;">{{ searchedGems.length }} gem{{ searchedGems.length === 1 ? '' : 's' }}</span>
      }

      <button type="button" class="btn btn-default" (click)="bulkImportDialogOpen = true"
        style="width: 36px; min-width: 36px; margin-right: 4px; border: none;" title="Bulk Import Gems">
        <span class="icon icon-download"></span>
      </button>

      @if (bulkImportDialogOpen) {
        <app-bulk-import-gems-dialog
          class="dialog-top"
          (close)="bulkImportDialogOpen = false"
          (import)="importGems($event)">
        </app-bulk-import-gems-dialog>
      }

      <app-autocomplete class="inline"
        [allLabel]="'None'"
        [options]="gemTypes"
        [disabled]="false"
        [showOptions]="true"
        [selectedValues]="filter.showSearchedGemTypes"
        (selectedValuesChange)="onSearchedGemsChange($event)">
      </app-autocomplete>

      {{ filter.classPreset }}
    </div>

    <div class="campaign-reset-section">
      <app-tooltip-wrapper [right]="true" class="regular-checkbox">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!showAll" (click)="showAll = !showAll"></button>
        </span>
        Show all <span class="extra-info"> (?)</span>
        <ng-template #tooltip>
          By default, only quests are shown which a) award a Book of Skill, b) reward or unlock gems you are looking for, c) contain a Lab or d) are otherwise important or required. Enabling this will show all quests.
        </ng-template>
      </app-tooltip-wrapper>

      <button type="button" class="btn clear-btn" (click)="resetProgress()" title="Reset all quest progress">
        Reset Progress
      </button>
    </div>
  </div>

  @for (part of parts; track part.label) {
    <div class="section-title-container">
      <h2 class="section-title gradient-title text-align-center" (click)="togglePart(part)">
        {{ part.label }}
        <span class="input-group-btn">
          <button class="btn toggle-btn caret-btn" [class.off]="!part.expanded"></button>
        </span>
      </h2>
    </div>

    <div [class.collapsed]="!part.expanded">
      @for (actVm of part.acts; track actVm.act) {
        <div class="filter-group">
          <div class="filter-group-header">
            <div class="filter">
              <span class="input-group-btn">
                <button class="btn toggle-btn caret-btn" [class.off]="!actVm.expanded" (click)="toggleAct(actVm)"></button>
              </span>
              <span class="filter-body">
                <span class="filter-title">
                  <span class="filter-title-text">Act {{ actVm.act }}</span>
                </span>
              </span>
            </div>
          </div>

          <div class="filter-group-body" [class.collapsed]="!actVm.expanded">
            @for (quest of actVm.quests; track quest.key) {
              @if (isQuestVisible(quest)) {
                <div class="filter filter-property full-span quest-row"
                  [class.quest-completed]="isQuestCompleted(quest.key)"
                  [class.quest-minor]="!quest.isImportant && !isQuestCompleted(quest.key)">
                  <span class="input-group-btn">
                    <button
                      class="btn toggle-btn"
                      [class.off]="!isQuestCompleted(quest.key)"
                      (click)="toggleQuest(quest.key)">
                    </button>
                  </span>
                  <span class="filter-body quest-body">
                    <span class="quest-name" [class.quest-name-done]="isQuestCompleted(quest.key)">{{ quest.name }}</span>
                    @if (quest.objective) {
                      <span class="quest-objective extra-info"> &mdash; {{ quest.objective }} </span>
                    }
                    @if (quest.locations.length > 0) {
                      <span class="separator">|</span>
                      <span class="quest-locations extra-info">
                        @for (loc of quest.locations; track loc; let last = $last) {
                          {{ loc }}@if (quest.zoneLevels.get(loc) != null) { ({{ quest.zoneLevels.get(loc) }}) }@if (!last) { · }
                        }
                      </span>
                    }
                    @if (quest.hasTrial) {
                      <span class="quest-trial" title="Contains a Trial of the Labyrinth">
                        <img [src]="imgPrefix + '/img/trial.png'" class="quest-trial-icon" alt="Lab Trial" />
                      </span>
                    }
                    @if (hasSearchedGems && quest.matchedGems.length > 0) {
                      <span class="separator">|</span>
                      <span class="quest-matched-gems">
                        @for (gem of quest.matchedGems; track gem) {
                          <app-item-label [baseType]="gem" [gem]="true" [inline]="true"></app-item-label>
                        }
                      </span>
                    }
                    @if (hasSearchedGems && quest.vendorGems.length > 0) {
                      <span class="quest-vendor-gems">
                        <span class="quest-gems-label">Unlocks:</span>
                        @for (gem of quest.vendorGems; track gem) {
                          <app-item-label [baseType]="gem" [gem]="true" [inline]="true"></app-item-label>
                        }
                      </span>
                    }
                    @if (quest.rewardDescription || quest.rewards.length > 0 || quest.rewardsSkill) {
                      <span class="separator">|</span>
                    }
                    @if (quest.rewardsSkill) {
                      <span class="quest-rewards">
                        <span class="quest-reward-item">
                          <img [src]="imgPrefix + '/img/book-of-skill.png'" class="quest-reward-icon" />
                          <span class="quest-reward-name">Book of Skill</span>
                        </span>
                      </span>
                    }
                    @if (quest.rewardDescription) {
                      <span class="quest-rewards">
                        <span
                          class="quest-reward-description normal-item-color"
                          [class.quest-reward-description-clickable]="quest.rewards.length > 0"
                          (click)="quest.rewards.length > 0 && (quest.rewardExpanded = !quest.rewardExpanded)">
                          {{ quest.rewardDescription }}
                          @if (quest.rewards.length > 0) {
                            <span class="quest-expand-icon">{{ quest.rewardExpanded ? '◀' : '▶' }}</span>
                          }
                        </span>
                        @if (quest.rewardExpanded) {
                          @for (reward of quest.rewards; track reward.name) {
                            <span class="quest-reward-item" [title]="reward.name">
                              @if (reward.img) {
                                <img [src]="imgPrefix + '/' + reward.img" class="quest-reward-icon" />
                              }
                              <span class="quest-reward-name">{{ reward.name }}</span>
                            </span>
                          }
                        }
                      </span>
                    } @else if (quest.rewards.length > 0) {
                      <span class="quest-rewards">
                        @for (reward of quest.rewards; track reward.name) {
                          <span class="quest-reward-item" [title]="reward.name">
                            @if (reward.img) {
                              <img [src]="imgPrefix + '/' + reward.img" class="quest-reward-icon" />
                              <span class="quest-reward-name">{{ reward.name }}</span>
                            } @else {
                              <span class="quest-reward-name">{{ reward.name }}</span>
                            }
                          </span>
                        }
                      </span>
                    }
                  </span>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }

}
